import { useState } from "react";
import styles from "./LoginForm.module.css";
import { Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { forgotPassword } from "../../services/api";
import T from '../T';

const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    setIsLoading(true);
    try {
      // Store user email for the reset step
      localStorage.setItem("forgot_password_email", email);

      // Trigger the forgot-password flow directly
      await forgotPassword(email);

      toast.success("A reset code has been sent to your email");

      // Navigate to the reset password page
      navigate("/reset-password");
    } catch (error) {
      if (import.meta.env.DEV) {
        console.error("Forgot password error:", error);
      }
      toast.error(
        error instanceof Error
          ? error.message
          : "Something went wrong. Please try again.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}><T>Forgot Password</T></h2>
        <p className={styles.subtitle}>
          <T>Enter your email address and we'll send you a code to reset your password.</T>
        </p>
      </div>

      <form className={styles.form} onSubmit={handleSubmit}>
        {/* Email */}
        <div className={styles.inputGroup}>
          <div className={styles.iconWrapper}>
            <Mail size={16} />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your.name@autochek.africa"
            className={styles.input}
            required
            disabled={isLoading}
          />
        </div>

        <button
          type="submit"
          className={styles.signInButton}
          disabled={isLoading}
        >
          {isLoading ? (
            <T>Sending code...</T>
          ) : (
            <>
              <T>Send Reset Code</T> <span className={styles.arrow}>→</span>
            </>
          )}
        </button>

        <div
          style={{
            marginTop: "1.5rem",
            textAlign: "center",
            fontSize: "0.9rem",
            color: "#6b7280",
          }}
        >
          <T>Remember your password?</T>{" "}
          <span
            onClick={() => navigate("/staff")}
            style={{ color: "#f5a623", cursor: "pointer", fontWeight: "500" }}
          >
            <T>Back to Login</T>
          </span>
        </div>
      </form>
    </div>
  );
};

export default ForgotPasswordForm;
